module.exports = __webpack_public_path__ + "img/registry.742b0f62.png";